<template>
  <div class="faq">
    <div id="left-pane">
      <div
        class="faq-card d-flex"
        @click="changeQuestion('resolution-windows')"
      >
        <v-card-text
          class="faq-title d-flex my-auto"
          :class="giveClass('resolution-windows')"
        >
          <strong>How to fix screen resolution in Windows?</strong>
        </v-card-text>
      </div>
      <div class="faq-card d-flex" @click="changeQuestion('resolution-mac')">
        <v-card-text
          class="faq-title d-flex my-auto"
          :class="giveClass('resolution-mac')"
        >
          <strong>How to fix screen resolution in Mac?</strong>
        </v-card-text>
      </div>
      <div class="faq-card d-flex" @click="changeQuestion('resolution-ubuntu')">
        <v-card-text
          class="faq-title d-flex my-auto"
          :class="giveClass('resolution-ubuntu')"
        >
          <strong>How to fix screen resolution in Ubuntu?</strong>
        </v-card-text>
      </div>
      <div class="faq-card d-flex" @click="changeQuestion('browser-zoom')">
        <v-card-text
          class="faq-title d-flex my-auto"
          :class="giveClass('browser-zoom')"
        >
          <strong>How to fix browser zoom level?</strong>
        </v-card-text>
      </div>
      <div class="faq-card d-flex" @click="changeQuestion('codingExecution')">
        <v-card-text
          class="faq-title d-flex my-auto"
          :class="giveClass('codingExecution')"
        >
          <strong> How to run coding question ? </strong>
        </v-card-text>
      </div>
    </div>
    <div class="right-pane">
      <div v-if="selectedQuestion === 'resolution-windows'">
        <faq-header />
        <br />
        <div>
          <faq-scalable-description os-name="Windows" :screen-resolution-err="true" />
          <faq-body
            os-name="Windows"
            image="https://drive.google.com/uc?export=view&id=1gUigwq4scScT5SX7Ti7PoF5PA8hPgsnm"
          />
        </div>
      </div>

      <div v-if="selectedQuestion === 'resolution-mac'">
        <faq-header />
        <br />
        <div>
          <faq-scalable-description os-name="Mac" />
          <faq-body
            os-name="Mac"
            image="https://drive.google.com/uc?export=view&id=10WK5xzDl-6od8beTUzMKiGVUFQFTWtI-"
          />
        </div>
      </div>

      <div v-if="selectedQuestion === 'resolution-ubuntu'">
        <faq-header />
        <br />
        <div>
          <faq-scalable-description os-name="Linux" :screen-resolution-err="true" />
          <faq-body
            os-name="Ubuntu"
            image="https://drive.google.com/uc?export=view&id=1FgMyB1w8NqgO4dQtL_nXT5Kkr5NJLGJf"
          />
        </div>
      </div>

      <div v-if="selectedQuestion === 'browser-zoom'">
        <faq-header />
        <br />
        <div>
          <faq-scalable-description :zoom-level-err="true" />
          <faq-body
            os-name="Ubuntu"
            image="https://drive.google.com/uc?export=view&id=1FgMyB1w8NqgO4dQtL_nXT5Kkr5NJLGJf"
          />
        </div>
      </div>

      <div v-if="selectedQuestion === 'codingExecution'">
        {{ codingExecutionContent }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  data: function() {
    return {
      selectedQuestion: 'resolution-windows',
      codingExecutionContent: 'How to run coding question ?',
    }
  },
  methods: {
    changeQuestion(question) {
      this.selectedQuestion = question
    },
    giveClass(question) {
      if (this.selectedQuestion === question) {
        return 'current_question'
      }
    },
  },
}
</script>

<style scoped>
.faq {
  display: flex;
  margin-top: 64px;
  flex: 1;
  max-height: calc(100% - 64px);
}

#left-pane {
  background: #ffffff;
  border-right: 1px solid #a8b2c6;
  color: #616262;
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
  max-width: 376px;
}

.right-pane {
  flex: 1;
  margin: 16px 0 16px 16px;
  background: #ffffff;
  color: #616262;
  overflow: auto;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

#left-pane .faq-card {
  margin-top: 4px;
  height: 80px;
  background: #f2f2f2;
  box-shadow: none;
  border-radius: 0;
  cursor: pointer;
}

.faq-title {
  height: 100%;
}

.current_question {
  color: blue;
}
</style>
